module.exports = __webpack_public_path__ + "static/media/laporan_kesiswaan.604a84f7.png";